import classNames from 'classnames';
import {
    FormattedMessage,
    useIntl,
} from 'react-intl';
import {NavLink} from 'react-router-dom';
import {Routes} from '../../../../Routes';

export function TrustAndPrivacyLink(props) {
    const {className, dataTestId} = props;

    const intl = useIntl();

    const linkClasses = classNames('link', className);

    return (
        <NavLink
            className={linkClasses}
            data-test-id={dataTestId ?? 'navigation-trust-and-privacy-link'}
            title={intl.formatMessage({id: 'navigation.link.trustAndPrivacy.title'})}
            to={Routes.TRUST_AND_PRIVACY}
        >
            <span>
                <FormattedMessage id={'navigation.link.trustAndPrivacy.text'} />
            </span>
        </NavLink>
    );
}
